<template>
  <div>
    <!-- 导航栏，非全屏模式显示 -->
    <van-nav-bar v-if="!isFullscreen" style="position: fixed; top: 0; left: 0; width: 100%; background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);" :title="$t(gameName)" left-arrow @click-left="$router.back()">
      <template #right>
        <div @click="toggleFullscreen" style="color: white; margin-right: 15px; font-size: 16px; cursor: pointer;">
          {{ $t('全屏') }}
        </div>
      </template>
    </van-nav-bar>
    <div v-if="!isFullscreen" style="height: 46px"></div>
    
    <!-- 全屏模式下的退出按钮 -->
    <div v-if="isFullscreen" class="fullscreen-exit-btn" @click="toggleFullscreen">
      <span class="exit-arrow">↑</span>
    </div>
    
    <!-- 游戏内容 -->
    <div v-if="url" :style="isFullscreen ? 'height: 100vh; overflow: hidden;' : 'height: calc(100vh - 46px); overflow-y: scroll; -webkit-overflow-scrolling: touch'">
      <iframe style="height: 100%; width: 100%"  ref="iframe" scrolling="auto" frameborder="0"  id="iframe"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      gameName: '',
      isFullscreen: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
     that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.name) {
      that.fetchGamesFromBackend(query.name, query.code || query.type);
      
      let gameName = query.game_name || query.title || query.gameTitle;
      if (!gameName) {
        const gameLists = [
          { name: 'fishingList', list: JSON.parse(localStorage.getItem('fishingList') || '[]') },
          { name: 'realbetList', list: JSON.parse(localStorage.getItem('realbetList') || '[]') },
          { name: 'sportList', list: JSON.parse(localStorage.getItem('sportList') || '[]') },
          { name: 'gamingList', list: JSON.parse(localStorage.getItem('gamingList') || '[]') },
          { name: 'jokerList', list: JSON.parse(localStorage.getItem('jokerList') || '[]') },
          { name: 'conciseList', list: JSON.parse(localStorage.getItem('conciseList') || '[]') },
          { name: 'lotteryList', list: JSON.parse(localStorage.getItem('lotteryList') || '[]') },
          { name: 'lhcList', list: JSON.parse(localStorage.getItem('lhcList') || '[]') },
          { name: 'jscList', list: JSON.parse(localStorage.getItem('jscList') || '[]') },
          { name: 'jwcList', list: JSON.parse(localStorage.getItem('jwcList') || '[]') },
          { name: 'qkcList', list: JSON.parse(localStorage.getItem('qkcList') || '[]') }
        ];
        
        const foundGames = [];
        for (const { name: listName, list } of gameLists) {
          const gameByCode = list.find(item => {
            const matchesPlatform = item.platform_name === query.name;
            const matchesCode = !query.type && !query.code || 
                              item.game_code === query.type || 
                              item.game_code === query.code;
            return matchesPlatform && matchesCode;
          });
          if (gameByCode) {
            foundGames.push({ source: 'code_match', list: listName, game: gameByCode });
          }
          const gameByPlatform = list.find(item => item.platform_name === query.name);
          if (gameByPlatform) {
            foundGames.push({ source: 'platform_match', list: listName, game: gameByPlatform });
          }
        }
        
        if (foundGames.length > 0) {
          foundGames.sort((a, b) => {
            if (a.source === 'code_match' && b.source !== 'code_match') return -1;
            if (a.source !== 'code_match' && b.source === 'code_match') return 1;
            return 0;
          });
          const bestMatch = foundGames[0].game;
          gameName = bestMatch.name || bestMatch.game_name || bestMatch.title;
        }
      }
      
      that.gameName = gameName || query.name;
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    
    // 【修改核心】：打开游戏
    // 打开游戏
        goGamePage(name, type, code) {
          let that = this;
          let currentLang = localStorage.getItem('locale') || 'zh';
    
          that.$apiFun
            .post('/api/getGameUrl', { 
                plat_name: name, 
                game_type: type || 0, 
                game_code: code, 
                is_mobile_url: 1,
                lang: currentLang 
            })
            .then(res => {
              if (res.code != 200) {
                that.$parent.showTost(0, res.message);
              }
              if (res.code == 200) {
                that.url = that.normalizeGameUrl(res.data.url);
                if (res.data.game_name) {
                  that.gameName = res.data.game_name;
                }
              }
            })
            .catch(res => {});
        },

    // JDB 等厂商会把 homeUrl / lang 拿去 .toLowerCase()。
    // 空的 homeUrl、重复的 lang（变成数组）都会直接崩。
    normalizeGameUrl(rawUrl) {
      if (!rawUrl) return rawUrl;
      let hashPart = '';
      const hashIndex = rawUrl.indexOf('#');
      if (hashIndex !== -1) {
        hashPart = rawUrl.substring(hashIndex);
        rawUrl = rawUrl.substring(0, hashIndex);
      }
      let parsed;
      try {
        parsed = new URL(rawUrl);
      } catch (e) {
        return rawUrl + hashPart;
      }
      if (!parsed.searchParams.get('homeUrl')) {
        parsed.searchParams.set('homeUrl', window.location.origin + '/');
      }
      const lang = parsed.searchParams.get('lang')
        || parsed.searchParams.get('l')
        || parsed.searchParams.get('language');
      if (lang) {
        parsed.searchParams.set('lang', String(lang));
      }
      return parsed.toString() + hashPart;
    },
    toggleFullscreen() {
      let that = this;
      if (!that.isFullscreen) {
        let elem = document.documentElement;
        if (elem.requestFullscreen) { elem.requestFullscreen(); } 
        else if (elem.webkitRequestFullscreen) { elem.webkitRequestFullscreen(); } 
        else if (elem.msRequestFullscreen) { elem.msRequestFullscreen(); }
        that.isFullscreen = true;
      } else {
        if (document.exitFullscreen) { document.exitFullscreen(); } 
        else if (document.webkitExitFullscreen) { document.webkitExitFullscreen(); } 
        else if (document.msExitFullscreen) { document.msExitFullscreen(); }
        that.isFullscreen = false;
      }
    },
    fetchGamesFromBackend(platformName, gameCode) {
      let that = this;
      const apiPaths = [
        '/api/game/list', 
        '/api/game/games', 
        '/api/games/list',
        '/api/game/game-lists', 
        '/api/game-lists', 
        '/api/game_lists' 
      ];
      let currentPathIndex = 0;
      
      const tryNextPath = () => {
        if (currentPathIndex >= apiPaths.length) return;
        const apiPath = apiPaths[currentPathIndex];
        currentPathIndex++;
        
        that.$apiFun.get(apiPath, { category: '' }).then(res => {
          if (res.code == 200 || res.status == 200) {
            let games = [];
            if (Array.isArray(res.data)) { games = res.data; } 
            else if (res.data && Array.isArray(res.data.list)) { games = res.data.list; } 
            else if (res.data && Array.isArray(res.data.games)) { games = res.data.games; } 
            else if (res.data && Array.isArray(res.data.game_lists)) { games = res.data.game_lists; }
            
            const gameByCode = games.find(item => {
              const matchesPlatform = item.platform_name === platformName || item.platform === platformName;
              const matchesCode = !gameCode || item.game_code === gameCode || item.code === gameCode || item.gameId === gameCode || item.type === gameCode;
              return matchesPlatform && matchesCode;
            });
            
            if (gameByCode) {
              that.gameName = gameByCode.name || gameByCode.game_name || gameByCode.title || gameByCode.gameName;
            } else {
              const gameByPlatform = games.find(item => item.platform_name === platformName || item.platform === platformName);
              if (gameByPlatform) {
                that.gameName = gameByPlatform.name || gameByPlatform.game_name || gameByPlatform.title || gameByPlatform.gameName;
              } else {
                const gameByCodeOnly = games.find(item => item.game_code === gameCode || item.code === gameCode || item.gameId === gameCode || item.type === gameCode);
                if (gameByCodeOnly) {
                  that.gameName = gameByCodeOnly.name || gameByCodeOnly.game_name || gameByCodeOnly.title || gameByCodeOnly.gameName;
                } else {
                  tryNextPath();
                }
              }
            }
          } else {
            tryNextPath();
          }
        }).catch(err => {
          tryNextPath();
        });
      };
      tryNextPath();
    },
  },
  updated() {
    let that = this;
    that.$refs.iframe.contentWindow.location.replace(that.url);
  },
};
</script>

<style>
.van-nav-bar__arrow { color: white !important; }
.van-icon-arrow-left { color: white !important; }
.van-nav-bar__title { color: white !important; font-weight: bold !important; }
.fullscreen-exit-btn {
  position: fixed; top: 10px; right: 10px; width: 40px; height: 40px;
  background-color: rgba(0, 0, 0, 0.5); border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; z-index: 9999; transition: all 0.3s ease;
}
.fullscreen-exit-btn:hover { background-color: rgba(0, 0, 0, 0.7); transform: scale(1.1); }
.exit-arrow { color: white; font-size: 20px; font-weight: bold; }
</style>


// WEBPACK FOOTER //
// src/components/mode/gamePage.vue